$(function () {
    $('.b-iconic-plates__plate').each(function(){
        var $context = $(this),
            $btnMore = $('.b-iconic-plates__project-more, .b-iconic-plates__project-min', $context);

        $btnMore.on('click', function (event) {
            event.preventDefault();

            if (!$context.is('.is-full-list')) {
                $context.addClass('is-full-list');
            } else {
                $context.removeClass('is-full-list');
            }
        });
    });
});
